import type { SeveritiesJobSchema } from "@/tools/aggregate/severities/types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SeveritiesState {
  /** Asset counts by run id from the progress stream. A run only saves its counts once it completes. */
  progress: {
    [k in string]: SeveritiesJobSchema["assets"];
  };
  /** Rows not yet posted, by run id, updated after each batch while a run uploads. */
  unprocessed: {
    [k in string]: number;
  };
}

const initialState: SeveritiesState = {
  progress: {},
  unprocessed: {},
};

export const severitiesSlice = createSlice({
  name: "severities",
  initialState,
  reducers: {
    setRunProgress: (state, action: PayloadAction<{ id: string; assets: SeveritiesJobSchema["assets"] }>) => {
      state.progress[action.payload.id] = action.payload.assets;
    },
    setRunUnprocessed: (state, action: PayloadAction<{ id: string; count: number }>) => {
      state.unprocessed[action.payload.id] = action.payload.count;
    },
  },
});

export const severitiesActions = severitiesSlice.actions;

export default severitiesSlice.reducer;
